export default "__VITE_ASSET__EpYFDE7t__"